// Constantes de recomendações e configurações para exames CFP e CFA

// Recomendações CFP (8 módulos - nova estrutura Planejar)
export const RECOMMENDED_CFP = [
  { module: "M1", value: 80 },
  { module: "M2", value: 75 },
  { module: "M3", value: 80 },
  { module: "M4", value: 80 },
  { module: "M5", value: 75 },
  { module: "M6", value: 75 },
  { module: "M7", value: 75 },
  { module: "M8", value: 80 }
];

// Recomendações CFA (10 módulos)
export const RECOMMENDED_CFA = [
  { module: "M1", value: 65 },
  { module: "M2", value: 75 },
  { module: "M3", value: 70 },
  { module: "M4", value: 60 },
  { module: "M5", value: 75 },
  { module: "M6", value: 80 },
  { module: "M7", value: 50 },
  { module: "M8", value: 90 },
  { module: "M9", value: 70 },
  { module: "M10", value: 90 }
];

// Dados dos módulos CFP para gráficos estáticos (8 módulos - nova estrutura Planejar)
export const CFP_MODULES = [
  { module: 1, questions: 18, recommended: 80, name: 'Planejamento Financeiro', weight: 12.9 },
  { module: 2, questions: 20, recommended: 75, name: 'Gestão Financeira', weight: 14.3 },
  { module: 3, questions: 24, recommended: 80, name: 'Investimentos e Gestão de Ativos', weight: 17.1 },
  { module: 4, questions: 17, recommended: 80, name: 'Aposentadoria', weight: 12.1 },
  { module: 5, questions: 17, recommended: 80, name: 'Seguros e Gestão de Riscos', weight: 12.1 },
  { module: 6, questions: 17, recommended: 75, name: 'Planejamento Tributário', weight: 12.1 },
  { module: 7, questions: 17, recommended: 75, name: 'Planejamento Patrimonial e Sucessório', weight: 12.1 },
  { module: 8, questions: 10, recommended: 80, name: 'Psicologia do Planejamento Financeiro', weight: 7.1 },
];

// Converte número do módulo para algarismo romano sem depender de tamanho fixo do array
export const getRomanModule = (moduleNumber) => {
  const numericValue = Number(moduleNumber);
  if (!Number.isFinite(numericValue) || numericValue <= 0) {
    return String(moduleNumber ?? '');
  }

  const romanMap = [
    { value: 1000, symbol: 'M' },
    { value: 900, symbol: 'CM' },
    { value: 500, symbol: 'D' },
    { value: 400, symbol: 'CD' },
    { value: 100, symbol: 'C' },
    { value: 90, symbol: 'XC' },
    { value: 50, symbol: 'L' },
    { value: 40, symbol: 'XL' },
    { value: 10, symbol: 'X' },
    { value: 9, symbol: 'IX' },
    { value: 5, symbol: 'V' },
    { value: 4, symbol: 'IV' },
    { value: 1, symbol: 'I' },
  ];

  let remaining = Math.floor(numericValue);
  let roman = '';

  romanMap.forEach(({ value, symbol }) => {
    while (remaining >= value) {
      roman += symbol;
      remaining -= value;
    }
  });

  return roman;
};

// Dados dos módulos CFA para gráficos estáticos
export const CFA_MODULES = [
  { module: 1, questions: 14, recommended: 65 },
  { module: 2, questions: 14, recommended: 75 },
  { module: 3, questions: 13, recommended: 70 },
  { module: 4, questions: 20, recommended: 60 },
  { module: 5, questions: 23, recommended: 75 },
  { module: 6, questions: 22, recommended: 80 },
  { module: 7, questions: 14, recommended: 50 },
  { module: 8, questions: 13, recommended: 90 },
  { module: 9, questions: 19, recommended: 70 },
  { module: 10, questions: 27, recommended: 90 },
];

// Helper para obter recomendações baseado no tipo de exame
export const getRecommendedByExamType = (examType) => {
  return examType === 'cfa' ? RECOMMENDED_CFA : RECOMMENDED_CFP;
};

// Helper para obter módulos baseado no tipo de exame
export const getModulesByExamType = (examType) => {
  return examType === 'cfa' ? CFA_MODULES : CFP_MODULES;
};

// Número de módulos por tipo de exame
export const MODULE_COUNT = {
  cfp: 8,
  cfa: 10
};
